import type { FaireProductEntity } from "../../entity_types/product";

export const p_tpww9nhj8f: FaireProductEntity = {
  token: "p_tpww9nhj8f",
  type: "product",
  name: "Precious Stones Chime™ - Tiger's-Eye",
  brandToken: "b_66wf2igxcf",
  brandName: "Woodstock Chimes",
  imageUrl:
    "https://cdn.faire.com/fastly/b0c4db16a83cf8ff07b1cad258b3938afe7bdb94e51134d8b8362b7d7fc3e4fd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd96f18c555261dcc87ffea7f05311d13be84709533af84bd54c864c02f4a251.jpeg",
    "https://cdn.faire.com/fastly/26385516023fac894af2debc13777bc8e67973a1019cf2f56bfcd90c3e24daca.jpeg",
    "https://cdn.faire.com/fastly/5ef72dcccc8c3dfa99c26b66e46cc28cf7c99da6edb43b2dda897d21e0d96bd1.jpeg",
  ],
  priceDollars: 10.39,
  description:
    "This chime must be purchased in bundles of 6 (6, 12, 18, 24...).\n\nEast Asian tradition values Tiger's Eye as a protective amulet when hung by the front door.\n\nOur Woodstock Precious Stones Chimes - Tiger's Eye incorporates genuine stone accents, making it as eye-catching as it is pleasing to the ear. \n\nThe Woodstock Precious Stones Chimes is a series of small wind chimes designed using colorful and meaningful accents.",
  tags: [],
  msrpDollars: 21.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:10.261Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
